export default __webpack_public_path__ + "67e64356a8409ab733523f7d95824934.svg";